import {ON_BOARD_SESSION} from "./AppOnboardingSession";

export const USER_ID_KEY = "userId";
export const USER_EMAIL_KEY = "userEmail";
export const USER_EMAIL_VERIFIED_KEY = "userEmailVerified";
export const USER_PHONE_NUMBER_KEY = "userPhoneNumber";
export const USER_NAME_KEY = "username";
export const USER_CODE_KEY = "userCode";
export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const SELECTED_PLACE = "selectedPlace";

export const VENUE_ID_KEY = "venueId";
export const VENUE_NAME_KEY = "venueName";

export const VENUE_PAYOUT_PIN_NUMBER_FEATURE_FLAG_KEY = "payoutPinNumberFeatureFlag";
export const VENUE_PAYOUT_SCAN_FEATURE_FLAG_KEY = "payoutScanFeatureFlag";
export const VENUE_DANCER_APP_MANAGEMENT_FEATURE_FLAG_KEY = "dancerAppManagementFeatureFlag";
export const VENUE_STAGE_TIP_FEATURE_FLAG_KEY = "stageTipFeatureFlag";
export const VENUE_REWARDS_FEATURE_FLAG_KEY = "venueRewardsFeatureFlag";
export const VENUE_STRIPE_PAYMENTS_FEATURE_FLAG_KEY = "venueStripePaymentsFeatureFlag";
export const VENUE_INPUT_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY = "venueInputCustomerCodePaymentsFeatureFlag";
export const VENUE_SCAN_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY = "venueScanCustomerCodePaymentsFeatureFlag";
export const VENUE_PRIVATE_DANCE_PAY_FEATURE_FLAG_KEY = "privateDancePayFeatureFlag";
export const VENUE_DANCE_PAY_FEATURE_FLAG_KEY = "dancePayFeatureFlag";
export const VENUE_DRINK_PAY_FEATURE_FLAG_KEY = "drinkPayFeatureFlag";
export const ROLES_KEY = "roles";

export const DANCER_ID_KEY = "dancerId";
export const DANCER_CODE_KEY = "dancerCode";
export const DANCER_VENUE_CODE_KEY = "dancerVenueCode";

export const TIPPED_AMOUNT_KEY = "tippedAmount";

export const USER_ROLE = "ROLE_USER";
export const MOD_ROLE = "ROLE_MODERATOR";
export const ADMIN_ROLE = "ROLE_ADMIN";
export const SELL_ROLE = "ROLE_SELL";
export const PAYOUT_ROLE = "ROLE_PAYOUT";
export const EDITDANCER_ROLE = "ROLE_EDITDANCER";
export const PAYINVOICE_ROLE = "ROLE_PAYINVOICE";
export const DANCEPAY_ROLE = "ROLE_DANCEPAY";
export const DRINKPAY_ROLE = "ROLE_DRINKPAY";
export const STAGEDISPLAY_ROLE = "ROLE_STAGEDISPLAY";
export const DANCER_CHECKIN = "ROLE_DANCERCHECKIN";

export const getRoleName = (role) => {
    if (role === USER_ROLE) {
        return "User";
    } else if (role === MOD_ROLE) {
        return "Moderator";
    } else if (role === ADMIN_ROLE) {
        return "Admin";
    } else if (role === SELL_ROLE) {
        return "Sell VirtualTipz";
    } else if (role === PAYOUT_ROLE) {
        return "Dancer Payout";
    } else if (role === EDITDANCER_ROLE) {
        return "Dancer Update";
    } else if (role === PAYINVOICE_ROLE) {
        return "Invoice Pay";
    } else if (role === DANCEPAY_ROLE) {
        return "Dance Sell";
    } else if (role === DRINKPAY_ROLE) {
        return "Drink Sell";
    } else if (role === STAGEDISPLAY_ROLE) {
        return "Stage Display";
    } else if (role === DANCER_CHECKIN) {
        return "Dancer Checkin";
    } else {
        return "";
    }
}

export const setSelectedPlace = async (
    selectedPlace
) => {
    await localStorage.setItem(SELECTED_PLACE, JSON.stringify(selectedPlace));
}

export const getSelectedPlace = async () => {
    const selectedPlace = localStorage.getItem(SELECTED_PLACE);
    return JSON.parse(selectedPlace);
}

export const createVenueSession = async (
    venueId,
    venueName,
    privateDancePayFeatureFlag,
    dancePayFeatureFlag,
    drinkPayFeatureFlag,
    stageTipFeatureFlag,
    venueRewardsFeatureFlag,
    venueStripePaymentsFeatureFlag,
    venueInputCustomerCodePaymentsFeatureFlag,
    venueScanCustomerCodePaymentsFeatureFlag
) => {
    await localStorage.setItem(VENUE_ID_KEY, venueId);
    await localStorage.setItem(VENUE_NAME_KEY, venueName);
    await localStorage.setItem(VENUE_PRIVATE_DANCE_PAY_FEATURE_FLAG_KEY, privateDancePayFeatureFlag);
    await localStorage.setItem(VENUE_DANCE_PAY_FEATURE_FLAG_KEY, dancePayFeatureFlag);
    await localStorage.setItem(VENUE_DRINK_PAY_FEATURE_FLAG_KEY, drinkPayFeatureFlag);
    await localStorage.setItem(VENUE_STAGE_TIP_FEATURE_FLAG_KEY, stageTipFeatureFlag);
    await localStorage.setItem(VENUE_REWARDS_FEATURE_FLAG_KEY, venueRewardsFeatureFlag);
    await localStorage.setItem(VENUE_STRIPE_PAYMENTS_FEATURE_FLAG_KEY, venueStripePaymentsFeatureFlag);
    await localStorage.setItem(VENUE_INPUT_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY, venueInputCustomerCodePaymentsFeatureFlag);
    await localStorage.setItem(VENUE_SCAN_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY, venueScanCustomerCodePaymentsFeatureFlag);
};

export const getVenueSession = async () => {
    try {
        const venueId = localStorage.getItem(VENUE_ID_KEY);
        const venueName = localStorage.getItem(VENUE_NAME_KEY);
        const privateDancePayFeatureFlag = localStorage.getItem(VENUE_PRIVATE_DANCE_PAY_FEATURE_FLAG_KEY);
        const dancePayFeatureFlag = localStorage.getItem(VENUE_DANCE_PAY_FEATURE_FLAG_KEY);
        const drinkPayFeatureFlag = localStorage.getItem(VENUE_DRINK_PAY_FEATURE_FLAG_KEY);
        const stageTipFeatureFlag = localStorage.getItem(VENUE_STAGE_TIP_FEATURE_FLAG_KEY);
        const venueRewardsFeatureFlag = localStorage.getItem(VENUE_REWARDS_FEATURE_FLAG_KEY);
        const venueStripePaymentsFeatureFlag = localStorage.getItem(VENUE_STRIPE_PAYMENTS_FEATURE_FLAG_KEY);
        const venueInputCustomerCodePaymentsFeatureFlag = localStorage.getItem(VENUE_INPUT_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY);
        const venueScanCustomerCodePaymentsFeatureFlag = localStorage.getItem(VENUE_SCAN_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY);
        const dancerAppManagementFeatureFlag = localStorage.getItem(VENUE_DANCER_APP_MANAGEMENT_FEATURE_FLAG_KEY);
        const payoutPinNumberFeatureFlag = localStorage.getItem(VENUE_PAYOUT_PIN_NUMBER_FEATURE_FLAG_KEY);
        const payoutScanFeatureFlag = localStorage.getItem(VENUE_PAYOUT_SCAN_FEATURE_FLAG_KEY);

        let sessionObject = {};
        sessionObject[VENUE_ID_KEY] = venueId;
        sessionObject[VENUE_NAME_KEY] = venueName;
        sessionObject[VENUE_PRIVATE_DANCE_PAY_FEATURE_FLAG_KEY] = privateDancePayFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_DANCE_PAY_FEATURE_FLAG_KEY] = dancePayFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_DRINK_PAY_FEATURE_FLAG_KEY] = drinkPayFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_STAGE_TIP_FEATURE_FLAG_KEY] = stageTipFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_REWARDS_FEATURE_FLAG_KEY] = venueRewardsFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_STRIPE_PAYMENTS_FEATURE_FLAG_KEY] = venueStripePaymentsFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_INPUT_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY] = venueInputCustomerCodePaymentsFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_SCAN_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY] = venueScanCustomerCodePaymentsFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_DANCER_APP_MANAGEMENT_FEATURE_FLAG_KEY] = dancerAppManagementFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_PAYOUT_PIN_NUMBER_FEATURE_FLAG_KEY] = payoutPinNumberFeatureFlag === "true" ? true : false;
        sessionObject[VENUE_PAYOUT_SCAN_FEATURE_FLAG_KEY] = payoutScanFeatureFlag === "true" ? true : false;

        return sessionObject;
    } catch (error) {
        // console.log("localStorage error: " + error.message);
    }
};

export const getUserId = async () => {
    const userId = localStorage.getItem(USER_ID_KEY);
    return userId;
}

export const getVenueId = async () => {
    const venueId = localStorage.getItem(VENUE_ID_KEY);
    return venueId;
}

export const getDancerId = async () => {
    const dancerId = localStorage.getItem(DANCER_ID_KEY);
    return dancerId;
}

export const createDancerLoginSession = async (
    dancerCode,
    dancerVenueCode
) => {
    if (dancerCode) {
        await localStorage.setItem(DANCER_CODE_KEY, dancerCode);
    }
    if (dancerVenueCode) {
        await localStorage.setItem(DANCER_VENUE_CODE_KEY, dancerVenueCode);
    }
};

export const createLoginSession = async (
    userId,
    username,
    email,
    emailVerified,
    // accessToken,
    // refreshToken,
    roles,
    userCode,
    venueId,
    dancerId,
    privateDancePayFeatureFlag,
    dancePayFeatureFlag,
    drinkPayFeatureFlag,
    stageTipFeatureFlag,
    venueRewardsFeatureFlag,
    venueStripePaymentsFeatureFlag,
    venueInputCustomerCodePaymentsFeatureFlag,
    venueScanCustomerCodePaymentsFeatureFlag,
    dancerAppManagementFeatureFlag,
    payoutPinNumberFeatureFlag,
    payoutScanFeatureFlag
) => {
    //await localStorage.setItem(USER_ID_KEY, JSON.stringify(userId));
    await localStorage.setItem(USER_ID_KEY, userId);
    await localStorage.setItem(USER_NAME_KEY, username);
    await localStorage.setItem(USER_EMAIL_KEY, email);
    await localStorage.setItem(USER_EMAIL_VERIFIED_KEY, emailVerified);
    // await localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    // await localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    await localStorage.removeItem(ON_BOARD_SESSION);
    await localStorage.setItem(ROLES_KEY, roles.toString());
    await localStorage.setItem(USER_CODE_KEY, userCode);
    if (venueId) {
        await localStorage.setItem(VENUE_ID_KEY, venueId);
        await localStorage.setItem(VENUE_PRIVATE_DANCE_PAY_FEATURE_FLAG_KEY, privateDancePayFeatureFlag);
        await localStorage.setItem(VENUE_DANCE_PAY_FEATURE_FLAG_KEY, dancePayFeatureFlag);
        await localStorage.setItem(VENUE_DRINK_PAY_FEATURE_FLAG_KEY, drinkPayFeatureFlag);
        await localStorage.setItem(VENUE_DANCER_APP_MANAGEMENT_FEATURE_FLAG_KEY, dancerAppManagementFeatureFlag);
        await localStorage.setItem(VENUE_STAGE_TIP_FEATURE_FLAG_KEY, stageTipFeatureFlag);
        await localStorage.setItem(VENUE_REWARDS_FEATURE_FLAG_KEY, venueRewardsFeatureFlag);
        await localStorage.setItem(VENUE_STRIPE_PAYMENTS_FEATURE_FLAG_KEY, venueStripePaymentsFeatureFlag);
        await localStorage.setItem(VENUE_INPUT_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY, venueInputCustomerCodePaymentsFeatureFlag);
        await localStorage.setItem(VENUE_SCAN_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY, venueScanCustomerCodePaymentsFeatureFlag);
        await localStorage.setItem(VENUE_PAYOUT_PIN_NUMBER_FEATURE_FLAG_KEY, payoutPinNumberFeatureFlag);
        await localStorage.setItem(VENUE_PAYOUT_SCAN_FEATURE_FLAG_KEY, payoutScanFeatureFlag);
    }
    if (dancerId) {
        await localStorage.setItem(DANCER_ID_KEY, dancerId);
    }
};

export const createVenueUserLoginSession = async (
    userId,
    username,
    email,
    accessToken,
    refreshToken,
    roles,
    userCode,
    venueId,
    dancerId,
    privateDancePayFeatureFlag,
    dancePayFeatureFlag,
    drinkPayFeatureFlag,
    stageTipFeatureFlag,
    venueRewardsFeatureFlag,
    venueStripePaymentsFeatureFlag,
    venueInputCustomerCodePaymentsFeatureFlag,
    venueScanCustomerCodePaymentsFeatureFlag
) => {
    //await localStorage.setItem(USER_ID_KEY, JSON.stringify(userId));
    await localStorage.setItem(USER_ID_KEY, userId);
    await localStorage.setItem(USER_NAME_KEY, username);
    await localStorage.setItem(USER_EMAIL_KEY, email);
    await localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    await localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    await localStorage.removeItem(ON_BOARD_SESSION);
    await localStorage.setItem(ROLES_KEY, roles.toString());
    await localStorage.setItem(USER_CODE_KEY, userCode);
    if (venueId) {
        await localStorage.setItem(VENUE_ID_KEY, venueId);
        await localStorage.setItem(VENUE_PRIVATE_DANCE_PAY_FEATURE_FLAG_KEY, privateDancePayFeatureFlag);
        await localStorage.setItem(VENUE_DANCE_PAY_FEATURE_FLAG_KEY, dancePayFeatureFlag);
        await localStorage.setItem(VENUE_DRINK_PAY_FEATURE_FLAG_KEY, drinkPayFeatureFlag);
        await localStorage.setItem(VENUE_STAGE_TIP_FEATURE_FLAG_KEY, stageTipFeatureFlag);
        await localStorage.setItem(VENUE_REWARDS_FEATURE_FLAG_KEY, venueRewardsFeatureFlag);
        await localStorage.setItem(VENUE_STRIPE_PAYMENTS_FEATURE_FLAG_KEY, venueStripePaymentsFeatureFlag);
        await localStorage.setItem(VENUE_INPUT_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY, venueInputCustomerCodePaymentsFeatureFlag);
        await localStorage.setItem(VENUE_SCAN_CUSTOMER_CODE_PAYMENTS_FEATURE_FLAG_KEY, venueScanCustomerCodePaymentsFeatureFlag);
    }
    if (dancerId) {
        await localStorage.setItem(DANCER_ID_KEY, dancerId);
    }
};

export const getLoginSession = async () => {
    try {
        const userId = localStorage.getItem(USER_ID_KEY);
        const userName = localStorage.getItem(USER_NAME_KEY);
        const userEmail = localStorage.getItem(USER_EMAIL_KEY);
        const roles = localStorage.getItem(ROLES_KEY);

        let sessionObject = {};
        sessionObject[USER_ID_KEY] = userId;
        sessionObject[USER_NAME_KEY] = userName;
        sessionObject[USER_EMAIL_KEY] = userEmail;
        sessionObject[ROLES_KEY] = roles;
        return sessionObject;
    } catch (error) {
        // console.log("localStorage error: " + error.message);
    }
};

export const getUserCode = async () => {
    try {
        const userCode = localStorage.getItem(USER_CODE_KEY);
        return userCode;
    } catch (error) {
        // console.log("localStorage error on isLoggedIn: " + error.message);
        return false;
    }
};

export const createEmailSession = async (
    email
) => {
    await localStorage.setItem(USER_EMAIL_KEY, email);
};

export const createPhoneNumberSession = async (
    phoneNumber
) => {
    await localStorage.setItem(USER_PHONE_NUMBER_KEY, phoneNumber);
};

export const getEmail = async () => {
    return localStorage.getItem(USER_EMAIL_KEY);
};

export const getEmailVerified = async () => {
    return localStorage.getItem(USER_EMAIL_VERIFIED_KEY);
};

export const getPhoneNumber = async () => {
    return localStorage.getItem(USER_PHONE_NUMBER_KEY);
};

export const clearEmailSession = async () => {
    await localStorage.removeItem(USER_EMAIL_KEY);
};

export const clearPhoneNumberSession = async () => {
    await localStorage.removeItem(USER_PHONE_NUMBER_KEY);
};

export const isLoggedIn = async () => {
    try {
        const token = localStorage.getItem(ACCESS_TOKEN_KEY);
        return token ? true : false;
    } catch (error) {
        // console.log("localStorage error on isLoggedIn: " + error.message);
        return false;
    }
};

export const isRichestInLoggedIn = async () => {
    try {
        const token = localStorage.getItem(ACCESS_TOKEN_KEY);
        const isOnboard = localStorage.getItem(ON_BOARD_SESSION);

        const isLoggedIn = token && (isOnboard !== "true");

        return isLoggedIn;
    } catch (error) {
        // console.log("localStorage error on isLoggedIn: " + error.message);
        return false;
    }
};

export const logOutSession = async () => {
    try {
        await localStorage.removeItem(USER_ID_KEY);
        await localStorage.removeItem(USER_NAME_KEY);
        await localStorage.removeItem(USER_EMAIL_KEY);
        await localStorage.removeItem(USER_EMAIL_VERIFIED_KEY);
        await localStorage.removeItem(USER_CODE_KEY);
        await localStorage.removeItem(ACCESS_TOKEN_KEY);
        await localStorage.removeItem(REFRESH_TOKEN_KEY);
        await localStorage.removeItem(ON_BOARD_SESSION);
        await localStorage.removeItem(VENUE_ID_KEY);
        await localStorage.removeItem(VENUE_NAME_KEY);
        await localStorage.removeItem(VENUE_PRIVATE_DANCE_PAY_FEATURE_FLAG_KEY);
        await localStorage.removeItem(VENUE_DANCE_PAY_FEATURE_FLAG_KEY);
        await localStorage.removeItem(VENUE_DRINK_PAY_FEATURE_FLAG_KEY);
        await localStorage.removeItem(VENUE_REWARDS_FEATURE_FLAG_KEY);
        await localStorage.removeItem(VENUE_STRIPE_PAYMENTS_FEATURE_FLAG_KEY);
        await localStorage.removeItem(VENUE_STAGE_TIP_FEATURE_FLAG_KEY);
        await localStorage.removeItem(VENUE_DANCER_APP_MANAGEMENT_FEATURE_FLAG_KEY);
        await localStorage.removeItem(ROLES_KEY);
    } catch (error) {
        // console.log("localStorage error on logout: " + error.message);
    }
};

// export const stripExpoToken = (token) => {
//     console.log("1 " + token);
//     token = token.replace("ExponentPushToken[", "");
//     console.log("2 " + token);
//     token = token.slice(0, -1);
//     console.log("3 " + token);
//     return token;
// };

// export const setAccessToken = async (accessToken) => {
//     await localStorage.setItem(
//         ACCESS_TOKEN_KEY,
//         accessToken
//     );
// };
//
// export const setRefreshToken = async (refreshToken) => {
//     await localStorage.setItem(
//         REFRESH_TOKEN_KEY,
//         refreshToken
//     );
// };

// export const getAccessToken = async () => {
//     try {
//         let accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
//         let sessionObject = {};
//
//         // accessToken = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pblVzZXIiLCJpYXQiOjE2ODAxMTgwODgsImV4cCI6MTcyMzExODA4OH0.kn2HeVo1EKHELPZNeb_BPVRMc26mO12WLRikUea3Kkt0biOA8laUO_KyWGqHz3H_jecu2nvrffEaR5LmlHVwRA";
//
//         sessionObject[ACCESS_TOKEN_KEY] = accessToken;
//         return sessionObject;
//     } catch (error) {
//         // console.log("localStorage error: " + error.message);
//     }
// };

// export const getRefreshToken = async () => {
//     try {
//         const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
//         let sessionObject = {};
//         sessionObject[REFRESH_TOKEN_KEY] = refreshToken;
//         // console.log("Refresh Token: " + refreshToken);
//         return sessionObject;
//     } catch (error) {
//         // console.log("localStorage error: " + error.message);
//     }
// };
